import { Component, Input } from '@angular/core';
import type { CommerceSolar, TrackedProductComponent } from '@analytics/models';
import { componentViewModelSelector } from '@core/experience-editor-utils';
import {
  mockSolarPanelsProductWithCalculations,
  type SolarPanelsProductWithCalculations,
} from '@innogy/feh/models';
import { getFieldValue } from '@core/jss-utils';
import { Store } from '@ngrx/store';
import type { TextField } from '@sitecore-jss/sitecore-jss-angular';
import type { Observable } from 'rxjs';
import {
  selectSelectedSolarPanelsProduct,
  SolarPanelsProductTrackingConfig,
} from '@feh/solar-panels-store';

import { SolarPanelsReceiptRendering } from '../../models/solar-panels-receipt-rendering.interface';

@Component({
  selector: 'wl-solar-panels-receipt-container[rendering]',
  templateUrl: './solar-panels-receipt-container.component.html',
})
export class SolarPanelsReceiptContainerComponent
  implements
    TrackedProductComponent<SolarPanelsProductWithCalculations, CommerceSolar>
{
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering!: SolarPanelsReceiptRendering;

  trackProductConfig = this.trackingConfig.config;

  product$: Observable<SolarPanelsProductWithCalculations | undefined> =
    this.store$.select(
      componentViewModelSelector(
        selectSelectedSolarPanelsProduct,
        mockSolarPanelsProductWithCalculations
      )
    );

  constructor(
    protected readonly store$: Store,
    private readonly trackingConfig: SolarPanelsProductTrackingConfig
  ) {}

  get title() {
    return getFieldValue(this.rendering, 'Title', '');
  }

  get amountAndTypeOfPanelsLabelField(): TextField {
    return this.rendering.fields.AmountAndTypeOfPanelsLabel;
  }

  get amountAndTypeOfPanelsValueField(): TextField {
    return this.rendering.fields.AmountAndTypeOfPanelsValue;
  }

  get productGuaranteeLabelField(): TextField {
    return this.rendering.fields.ProductGuaranteeLabel;
  }

  get productGuaranteeValueField(): TextField {
    return this.rendering.fields.ProductGuaranteeValue;
  }

  get powerGuaranteeLabelField(): TextField {
    return this.rendering.fields.PowerGuaranteeLabel;
  }

  get powerGuaranteeValueField(): TextField {
    return this.rendering.fields.PowerGuaranteeValue;
  }

  get estimatedYearlyRevenueLabelField(): TextField {
    return this.rendering.fields.EstimatedYearlyRevenueLabel;
  }

  get estimatedYearlyRevenueValueField(): TextField {
    return this.rendering.fields.EstimatedYearlyRevenueValue;
  }

  get savingsPerYearLabelField(): TextField {
    return this.rendering.fields.SavingsPerYearLabel;
  }

  get savingsPerYearTooltip() {
    const description = getFieldValue(
      this.rendering,
      'SavingsPerYearTooltip',
      ''
    );
    return { description };
  }
}
